import { memo, useContext } from 'react';

import { Button } from 'antd';

import { LayoutContext } from '@/layouts/baseLayout/provider';

const Index = (props) => {
  const { resourceData } = useContext(LayoutContext);
  const { matchCatalog, isMro, matchBrand } = props;

  return (
    <>
      {matchBrand && (
        <section className={'mb-[11px] flex items-center  text-[14px] '}>
          <div className={'mr-[10px] font-bold text-[#000000]'}>{matchBrand?.label}</div>
          <div className={'mr-[10px] text-[#444444]'}>
            共<span className={'px-[2px] text-[#0093E6]'}>{matchBrand?.count}</span>
            件相关商品
          </div>
          <a
            data-spm="mb"
            href={`${resourceData?.projectConfigVO?.lcscListUrl}${isMro ? '/mro' : ''}/brand/${matchBrand?.value}.html`}
          >
            <Button className={'h-[28px] text-[12px]'} ghost={true} type={'primary'}>
              进入品牌
            </Button>
          </a>
        </section>
      )}
      {matchCatalog && (
        <section className={'mb-[11px] flex items-center  text-[14px] '}>
          <div className={'mr-[10px] font-bold text-[#000000]'}>{matchCatalog?.label}</div>
          <div className={'mr-[10px] text-[#444444]'}>
            共<span className={'px-[2px] text-[#0093E6]'}>{matchCatalog?.count}</span>
            件相关商品
          </div>
          <a
            data-spm="mc"
            href={`${resourceData?.projectConfigVO?.lcscListUrl}/catalog/${matchCatalog?.value}.html${isMro ? '?mro=1' : ''}`}
          >
            <Button className={'h-[28px] text-[12px]'} ghost={true} type={'primary'}>
              进入目录
            </Button>
          </a>
        </section>
      )}
    </>
  );
};

export default memo(Index);
